import React, { useEffect } from 'react';

import { DateTime } from 'luxon';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOrder } from '../hooks/order';

interface ITableProvider {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
}

const TableProvider: React.FC<ITableProvider> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { table } = useOrder();

  useEffect(() => {
    const tableDate = sessionStorage.getItem('@BSFOOD:table_session');
    if (tableDate && table.tableNumber > 0) {
      if (tableDate && typeof tableDate === 'string') {
        const { minutes } = DateTime.fromMillis(Number(tableDate)).diffNow('minutes').toObject();

        if (minutes && minutes < -40) {
          sessionStorage.removeItem('@BSFOOD:table_session');
          navigate('/table', {
            state: { expired: true, isOrder: table.tableNumber > 0 },
          });
        }
      }
    }
  }, [navigate, location, table]);

  // Verifique se children existe, caso contrário, retorne null
  return children || null;
};
export default TableProvider;
